/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import * as l10n from './ServicePortController.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @ngdoc controller
 * @name ServicePortController
 */
class ServicePortController {
    constructor($scope, l10nService) {
        $scope.l10nKeys = l10nKeys;
        l10nService.registerSourceBundles(dictionary);
    }
}

ServicePortController.$inject = [
    '$scope',
    'l10nService',
];

angular.module('aviApp').controller('ServicePortController', ServicePortController);
